var React = require('react');

function BackIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 15a1 1 0 0 1-1.414 0l-7-7 7-7A1 1 0 1 1 11 2.414L5.414 8 11 13.586A1 1 0 0 1 11 15z","fill":"#fff"}));
}

BackIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = BackIcon;

BackIcon.default = BackIcon;
